import React, { useState } from "react";

const GetTime = () => {

    let newTime = new Date().toLocaleTimeString();

    const [ctime, setCtime] = useState(newTime);

    const UpdateTime = () =>{
        newTime = new Date().toLocaleTimeString();
        setCtime (newTime);
    }

    return (
        <>
            <h1>{newTime}</h1>
            <button className="btn btn-primary" onClick={UpdateTime}>Get Time</button>
        </>
    )
}
export default GetTime;